/** テレビデモの放送案（会議比較用） */

export const TV_BROADCAST_MODES = {
  WEEKLY: 'weekly',
  DAILY: 'daily',
};

export const TV_BROADCAST_MODE_OPTIONS = [
  { id: TV_BROADCAST_MODES.WEEKLY, label: '週間版' },
  { id: TV_BROADCAST_MODES.DAILY, label: '日別版（現行）' },
];

/** 会議用プロトタイプの初期表示は週間版 */
export const TV_BROADCAST_DEFAULT_MODE = TV_BROADCAST_MODES.WEEKLY;
